module.exports = __webpack_public_path__ + "img/2.46a4825c.png";